import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./AuthContext";
import App from "./App";
import GuestFeedbackPage from "./pages/GuestFeedbackPage";
import FigueroaEightParkingPage from "./pages/FigueroaEightParkingPage";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

// Public guest feedback routing — token path only:
//
//   /feedback/t/:token    → PRODUCTION QR path. Calls resolveFeedbackPublicToken
//                           and submitFeedbackByToken. No locationId is ever
//                           sent from the client; the backend derives the
//                           location from the token doc.
//
//   /feedback/:locationId → retired legacy path. It renders an unavailable
//                           state and never calls a location-based callable.
const guestFeedbackTokenMatch    = window.location.pathname.match(/^\/feedback\/t\/([^/]+)\/?$/);
const guestFeedbackLocationMatch = !guestFeedbackTokenMatch
  ? window.location.pathname.match(/^\/feedback\/([^/]+)\/?$/)
  : null;

if (window.location.pathname === "/figueroa-eight/parking" || window.location.pathname === "/figueroa-eight/parking/") {
  createRoot(rootElement).render(
    <StrictMode>
      <FigueroaEightParkingPage />
    </StrictMode>
  );
} else if (guestFeedbackTokenMatch) {
  const token = decodeURIComponent(guestFeedbackTokenMatch[1]);
  createRoot(rootElement).render(
    <StrictMode>
      <GuestFeedbackPage token={token} />
    </StrictMode>
  );
} else if (guestFeedbackLocationMatch) {
  // Retired location-only links must not select a tenant or submit feedback.
  createRoot(rootElement).render(
    <StrictMode>
      <GuestFeedbackPage invalidLink />
    </StrictMode>
  );
} else {
  createRoot(rootElement).render(
    <StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </StrictMode>
  );
}
